import { MovementLocationType } from "../../enums/movements/movement-location-type";
import { MovementStatus } from "../../enums/movements/movement-status";
import {MovementMean} from "../../movement/movement-mean";

export class FilterBoatMovement {
  queueIds?: number[];
  groupIds?: number[];
	currentLocationType?: MovementLocationType[];
	destinyType?: MovementLocationType[];
	movementStatus?: MovementStatus[];
  highlightInteractions?: number;
  boatId?: number;
  movementMeanIds?: MovementMean[]
}
